export const getMatchStyling = (isMatch: boolean) => (isMatch ? { fontWeight: 'bold' } : {});
